module.exports = __webpack_public_path__ + "img/DISH-Wally-Accessories.be1fa5df.jpg";